import styled from '@emotion/styled';
import { Select } from 'src/components-dummy';

export const SelectStyled = styled(Select)`
  margin-top: 32px;
  max-width: 326px;
`;
